import { c as _c } from "react/compiler-runtime";
import { Button } from "@website/ui/button";
import { replaceSnappTripBasedOnChannel } from "@website/utils/title-replace";
import { useCompatRouter } from "@website/widget-v2/helpers/compat-router.hook";
import { Header } from "@website/widget/login/components";
import styles from "@website/widget/login/components/password-change-successful-card/password-change-successful-card.module.scss";
import { FC } from "react";
import approvedImage from "../../../../assets/images/approved.png";
export const PasswordChangeSuccessfulCard: FC = () => {
  const $ = _c(12);
  const router = useCompatRouter();
  let t0;
  if ($[0] !== router) {
    t0 = () => {
      router?.push(router?.pathname, {
        ...router?.query,
        ["login_step"]: "password"
      }, {
        shallow: true,
        scroll: false
      });
    };
    $[0] = router;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const onClose = t0;
  let t1;
  if ($[2] !== onClose) {
    t1 = <Header onClose={onClose} />;
    $[2] = onClose;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className={styles["image-container"]}><img alt={"\u062A\u06CC\u06A9 \u0633\u0628\u0632"} height={approvedImage.height} src={approvedImage.src} width={approvedImage.width} /></div>;
    t3 = <div className={styles.info}>رمز عبور شما با موفقیت تغییر کرد</div>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = replaceSnappTripBasedOnChannel("\u0648\u0631\u0648\u062F \u0628\u0647 \u0627\u0633\u0646\u067E\u200C\u062A\u0631\u06CC\u067E!");
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== onClose) {
    t5 = <div className={styles.footer}><Button color="secondary" fullWidth={true} onClick={onClose} size="large" variant="contained">{t4}</Button></div>;
    $[7] = onClose;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t1 || $[10] !== t5) {
    t6 = <div className={styles.container}>{t1}{t2}{t3}{t5}</div>;
    $[9] = t1;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};